import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { headers, DELETE_VENDOR_WORK_ORDER, GET_VENDOR_WORK_ORDER_DETAILS, GET_VENDOR_WORK_ORDER_LIST, INSERT_UPDATE_VENDOR_WORK_ORDER, getVendorWorkOrderListUrl, insertUpdateVendorWorkOrderUrl, getVendorWorkOrderDetailsUrl, deleteVendorWorkOrderUrl, CREATE_HALL_MANAGER_ACCESS, createhallManagerAccessUrl, SOW_TAG_READ, SOWTagReadUrl, GET_DELIVERABLES_DOCUMENT_LOG, getDeliverablesDocumentLogUrl, createZoneManagerTeamMemberUrl, deleteZoneManagerTeamMemberUrl, CREATE_ZONE_MANAGER_TEAM_MEMBER, DELETE_ZONE_MANAGER_TEAM_MEMBER } from "../../../../utils/constants";


export const getVendorWorkOrderList_action = (ExhibitionID, WorkOrderNumber, Services, PersonName, EmailID, Status) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
            WorkOrderNumber: WorkOrderNumber != '' ? WorkOrderNumber : null,
            Services: Services != '' ? Services : null,
            PersonName: PersonName != '' ? PersonName : null,
            EmailID: EmailID != '' ? EmailID : null,
            Status: Status != '' ? Status : null,
        }

        const res = await axiosGet(getVendorWorkOrderListUrl, params, headers)

        dispatch({
            type: GET_VENDOR_WORK_ORDER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateVendorWorkOrder_action = (WorkOrderID, ExhibitionID, VendorID, WorkOrderNumber, WorkOrderServices, PersonName, EmailID, MobileNumber, StartDate, EndDate, DeliverablesServicesList, OrganizerResponsibilitiesList, PreSetupDaysList, EventStaffSectionList, DismantlingStaffSectionList, PreSetupStaffHallMappingList, EventDayStaffHallMappingList, DismantlingStaffHallMapping, DeliverableComplianceList, PresetupStaffCountList, DismantlingStaffCountList, DocumentSectionList, IsSubmitted, PlanSubmissionDateList, IsUpdate, formType, DeliverablesDocumentsList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            WorkOrderID: WorkOrderID != '' ? parseInt(WorkOrderID) : null,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
            VendorID: VendorID != '' ? VendorID : null,
            WorkOrderNumber: WorkOrderNumber != '' ? WorkOrderNumber : null,
            WorkOrderServices: WorkOrderServices != '' ? WorkOrderServices : null,
            PersonName: PersonName != '' ? PersonName : null,
            EmailID: EmailID != '' ? EmailID : null,
            MobileNumber: MobileNumber != '' ? MobileNumber : null,
            StartDate: StartDate != '' ? StartDate : null,
            EndDate: EndDate != '' ? EndDate : null,
            DeliverablesServicesList: DeliverablesServicesList,
            OrganizerResponsibilitiesList: OrganizerResponsibilitiesList,
            PreSetupDaysList: PreSetupDaysList,
            EventStaffSectionList: EventStaffSectionList,
            DismantlingStaffSectionList: DismantlingStaffSectionList,
            PreSetupStaffHallMappingList: PreSetupStaffHallMappingList,
            EventDayStaffHallMappingList: EventDayStaffHallMappingList,
            DismantlingStaffHallMapping: DismantlingStaffHallMapping,
            DeliverableComplianceList: DeliverableComplianceList,
            DocumentSectionList: DocumentSectionList,
            PresetupStaffCountList: PresetupStaffCountList,
            DismantlingStaffCountList: DismantlingStaffCountList,
            IsSubmitted: IsSubmitted,
            PlanSubmissionDateList: PlanSubmissionDateList,
            IsUpdate: IsUpdate,
            IsHallManager: JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 7,
            FormType: formType,
            DeliverablesDocumentsList: DeliverablesDocumentsList,
        }

        const res = await axiosPost(insertUpdateVendorWorkOrderUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_VENDOR_WORK_ORDER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getVendorWorkOrderDetails_action = (WorkOrderID, ExhibitionID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            WorkOrderID: WorkOrderID != '' ? parseInt(WorkOrderID) : null,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
        }

        const res = await axiosGet(getVendorWorkOrderDetailsUrl, params, headers)

        dispatch({
            type: GET_VENDOR_WORK_ORDER_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteVendorWorkOrder_action = (WorkOrderID, ExhibitionID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            WorkOrderID: WorkOrderID != '' ? parseInt(WorkOrderID) : null,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
        }

        const res = await axiosGet(deleteVendorWorkOrderUrl, params, headers)

        dispatch({
            type: DELETE_VENDOR_WORK_ORDER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const createhallManagerAccess_action = (ExhibitionID, VendorID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
            VendorID: VendorID != '' ? parseInt(VendorID) : null,
        }

        const res = await axiosPost(createhallManagerAccessUrl, params, headers)

        dispatch({
            type: CREATE_HALL_MANAGER_ACCESS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const SOWTagRead_action = (ExhibitionID, WorkOrderID, SOWTagReadList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
            WorkOrderID: WorkOrderID,
            SOWTagReadList: SOWTagReadList,
        }

        const res = await axiosPost(SOWTagReadUrl, params, headers)

        dispatch({
            type: SOW_TAG_READ,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDeliverablesDocumentLog_action = (ExhibitionID, WorkOrderID, WorkOrderDeliverablesID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
            WorkOrderID: WorkOrderID,
            WorkOrderDeliverablesID: WorkOrderDeliverablesID,
        }

        const res = await axiosGet(getDeliverablesDocumentLogUrl, params, headers)

        dispatch({
            type: GET_DELIVERABLES_DOCUMENT_LOG,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}


export const createZoneManagerTeamMember_action = (ExhibitionID, EmailID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
            EmailID:EmailID
        }

        const res = await axiosPost(createZoneManagerTeamMemberUrl, params, headers)

        dispatch({
            type: CREATE_ZONE_MANAGER_TEAM_MEMBER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteZoneManagerTeamMember_action = (ExhibitionID, EmailID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
            EmailID:EmailID
        }

        const res = await axiosGet(deleteZoneManagerTeamMemberUrl, params, headers)

        dispatch({
            type: DELETE_ZONE_MANAGER_TEAM_MEMBER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}